import './App.scss';
import 'antd/dist/antd.min.css';
import {
  Redirect, Route, Switch, NavLink,
} from 'react-router-dom';
import ToasterAlert from '../src/Shared/Utils/ToasterUtils';
import ComplaintDetails from "../src/Pages/ComplaintDetails/ComplaintDetails";
import ComplaintsListing from "../src/Pages/ComplaintsListing/ComplaintsListing";
import RoHomePage from "../src/Pages/RoHomePage/RoHomePage";
import StateHomePage from "../src/Pages/StateHomePage/StateHomePage";
import CpcbHomePage from './Pages/CPCB_HomePage/CpcbHomePage';
import AdminSettings from "../src/Pages/AdminSettings/AdminSettings.js";
import UserLogin from './Pages/UserLogin/UserLogin';
import { SecureLogout } from '../src/Shared/Utils/ProvideAuth';
import ProtectedRoute from './Shared/Utils/ProtectedRoute';
function App() {
  return (
    <>
      <ToasterAlert />
      <div className="App" data-test="app-container">
        <Switch>
          <ProtectedRoute exact path="/login" component={UserLogin} />
          <Route exact path="/logout" component={SecureLogout} />
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          {/* <Route exact path="/complaint-details/:id">
            <ComplaintDetails />
          </Route> */}

          <ProtectedRoute exact path="/complaints-list" component={ComplaintsListing} />
          <ProtectedRoute exact path="/ro-home" component={RoHomePage} />
          <ProtectedRoute exact path="/state-home" component={StateHomePage} />

          <ProtectedRoute path="/cpcb-home" component={CpcbHomePage} />
          <Route exact path="/admin-settings">
            <AdminSettings />
          </Route>
          <Route exact path="*" component={SecureLogout} />
        </Switch>
      </div>
    </>
  );
}

export default App;
